import { MultiSelect } from '@shared/components/forms';
import {
  type StringOption,
  stringOptionsToValues,
  useStringOptions,
} from '@shared/helpers/string-options';
import { useCallback, useContext, useMemo } from 'react';
import { ProductTableContext } from '../../../contexts/product-table-context';
import type { Product } from '../../../data/product';
import type { Filters } from '../../../hooks/products';
import { withFilterField } from './filter-component';
import { FilterWrapper } from './filter-wrapper';

export const TypeFilter = withFilterField(
  'types',
  function TypeFilter({ products }: { products: Product[] }) {
    const { filters, setFilters } = useContext(ProductTableContext);
    const { types } = filters;

    const allTypes = useMemo(() => {
      const types = new Set<string>();
      for (const product of products) {
        types.add(product.type);
      }

      //convert set to array
      return [...types].filter((type) => type.trim() !== '').sort();
    }, [products]);
    const options = useStringOptions(allTypes);

    const value = useStringOptions(types);
    const onChange = useCallback(
      (typeOptions: readonly StringOption[]) => {
        const types = stringOptionsToValues(typeOptions);
        setFilters((prev: Filters) => ({ ...prev, types }));
      },
      [setFilters]
    );

    return (
      <FilterWrapper label="Type">
        <MultiSelect
          options={options}
          value={value}
          onChange={onChange}
          placeholder="Any"
          isMulti
        />
      </FilterWrapper>
    );
  }
);
